// extracted by mini-css-extract-plugin
export var container = "index-module--container--y3+7D";
export var descriptionBox = "index-module--descriptionBox--MFYaZ";
export var imageBox = "index-module--imageBox--0HfeR";
export var imageWrapper = "index-module--imageWrapper--tVfMI";
export var motto = "index-module--motto--tUujR";
export var subtitle = "index-module--subtitle--JMpye";
export var title = "index-module--title--NlAzx";